import type { CardProps } from "@karrtopelka/cards/types";
import { drawProvocation } from "@karrtopelka/cards/provocations";

/** Win card: the call streak. The shared ritual does the provoking. */
export function buildDrawCard(streak: number, handle: string): CardProps {
  return {
    game: "draw",
    display: String(streak),
    handle,
    provocation: drawProvocation(streak),
    date: new Date().toISOString().slice(0, 10),
  };
}
